<template>
    <div class="h-full">
      <TopAppBar
          :leftBtnMode="leftBtnMethod"
          :rightBtnMode="rightBtnMode"
          :title="title"
          :leftBtnMethod="leftBtnMethod"
          :rightBtnMethod="rightBtnMethod"
          :hideCategory="false"
          staticMode="true"
      >
      </TopAppBar>
      <div class="d-flex flex-column h-full">
        <TopAppBarDrawer></TopAppBarDrawer>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import {topAppBarMixin} from '@/mixins/topAppBar.js';
import CategoryList from "@/components/common/CategoryList.vue";
import ServiceCategoryList from "@/components/common/ServiceCategoryList.vue";

export default {
  name: "MicroDegree",

  data() {
    return {
      leftBtnMethod: () => { this.$router.go(-1)}
    }
  },

  components: {
    TopAppBar,
    TopAppBarDrawer
  },

  mixins: [topAppBarMixin],

  mounted() {
    document.querySelector('html').setAttribute("data-theme", "dark");
    let	title = localStorage.getItem('brandName');
    let learnBack = localStorage.getItem("learning");
    if(learnBack === 'myinformation') {
      localStorage.removeItem("learning");
      this.setTopAppBarBackToMyInformation(title);
    } else {
      this.setTopAppBarHomeSearch(title);
    }
  },
}
</script>

<style scoped>

</style>
